"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        root: {
            width: 55,
            height: 29,
            padding: 0,
            margin: theme.spacing(1),
        },
        switchBase: {
            padding: 1,
            '&$checked': {
                transform: 'translateX(26px)',
                color: theme.palette.common.white,
                '& + $track': {
                    backgroundColor: '#6d9067',
                    opacity: 1,
                    border: 'none',
                },
            },
            '&$focusVisible $thumb': {
                color: '#52d869',
                border: '6px solid #fff',
            },
        },
        thumb: {
            width: 27,
            height: 27,
        },
        track: {
            borderRadius: 29 / 2,
            border: '1px solid #bbbbbb',
            backgroundColor: '#f0f0f0',
            opacity: 1,
            transition: theme.transitions.create(['background-color', 'border']),
        },
        checked: {},
        focusVisible: {},
    });
});
function GoSwitch(_a) {
    var color = _a.color, checked = _a.checked, className = _a.className, onChange = _a.onChange;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Switch, { className: className, focusVisibleClassName: classes.focusVisible, disableRipple: true, classes: {
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
        }, color: color, checked: checked, onChange: onChange }));
}
exports.default = GoSwitch;
